import { MutableRefObject, RefCallback } from "react";

/**
Assigns multiple refs to a single element. This is useful when you need to assign multiple refs to a single element.
A ref can either be a callback or a mutable ref object.
**/
export function mergeRefs<T extends HTMLElement>(
    ...inputRefs: Array<MutableRefObject<T | null> | RefCallback<T> | undefined>
): RefCallback<T> {
    return (ref) => {
        inputRefs.forEach((inputRef) => {
            if (!inputRef) {
                return;
            }

            if (typeof inputRef === "function") {
                inputRef(ref);
            } else {
                inputRef.current = ref;
            }
        });
    };
}
